/**
 * @generated SignedSource<<ecd037cd432c812e97c9290a4e14595f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateEditChannelModalEditMutation$variables = {
  channelId: string;
  description?: string | null;
  isPrivate: boolean;
  members?: ReadonlyArray<string> | null;
  name: string;
};
export type CreateEditChannelModalEditMutation$data = {
  readonly editChannel: {
    readonly channel: {
      readonly activeSmartTrackers: ReadonlyArray<{
        readonly name: string;
        readonly triggerPhrasesOrWords: ReadonlyArray<string>;
      }>;
      readonly description: string | null;
      readonly id: string;
      readonly isMember: boolean;
      readonly isPrivate: boolean;
      readonly isWorkspaceWide: boolean;
      readonly lastPostedAt: string | null;
      readonly members: ReadonlyArray<{
        readonly email: string;
        readonly fullName: string;
        readonly id: string;
        readonly image: string;
      }>;
      readonly name: string;
      readonly postsCount: number;
    };
  } | null;
};
export type CreateEditChannelModalEditMutation = {
  response: CreateEditChannelModalEditMutation$data;
  variables: CreateEditChannelModalEditMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "channelId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "description"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isPrivate"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "members"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "name"
},
v5 = [
  {
    "kind": "Variable",
    "name": "channelId",
    "variableName": "channelId"
  },
  {
    "kind": "Variable",
    "name": "description",
    "variableName": "description"
  },
  {
    "kind": "Variable",
    "name": "isPrivate",
    "variableName": "isPrivate"
  },
  {
    "kind": "Variable",
    "name": "members",
    "variableName": "members"
  },
  {
    "kind": "Variable",
    "name": "name",
    "variableName": "name"
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isMember",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPrivate",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isWorkspaceWide",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastPostedAt",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "postsCount",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "members",
  "plural": true,
  "selections": [
    (v6/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fullName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "image",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "triggerPhrasesOrWords",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateEditChannelModalEditMutation",
    "selections": [
      {
        "alias": null,
        "args": (v5/*: any*/),
        "concreteType": "EditChannel",
        "kind": "LinkedField",
        "name": "editChannel",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Channel",
            "kind": "LinkedField",
            "name": "channel",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "SmartTracker",
                "kind": "LinkedField",
                "name": "activeSmartTrackers",
                "plural": true,
                "selections": [
                  (v7/*: any*/),
                  (v15/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v4/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "CreateEditChannelModalEditMutation",
    "selections": [
      {
        "alias": null,
        "args": (v5/*: any*/),
        "concreteType": "EditChannel",
        "kind": "LinkedField",
        "name": "editChannel",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Channel",
            "kind": "LinkedField",
            "name": "channel",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "SmartTracker",
                "kind": "LinkedField",
                "name": "activeSmartTrackers",
                "plural": true,
                "selections": [
                  (v7/*: any*/),
                  (v15/*: any*/),
                  (v6/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "4a6327fee9b5c79aea5c615306bfb0c1",
    "id": null,
    "metadata": {},
    "name": "CreateEditChannelModalEditMutation",
    "operationKind": "mutation",
    "text": "mutation CreateEditChannelModalEditMutation(\n  $channelId: ID!\n  $name: String!\n  $isPrivate: Boolean!\n  $description: String\n  $members: [ID!]\n) {\n  editChannel(channelId: $channelId, name: $name, isPrivate: $isPrivate, description: $description, members: $members) {\n    channel {\n      id\n      name\n      description\n      isMember\n      isPrivate\n      isWorkspaceWide\n      lastPostedAt\n      postsCount\n      members {\n        id\n        email\n        fullName\n        image\n      }\n      activeSmartTrackers {\n        name\n        triggerPhrasesOrWords\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "1c19610f3b3e62cc7e0c83b10ea1f280";

export default node;
